/* eslint-disable no-unused-vars */
import { createContext, useContext, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { useLocation } from 'react-router';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import { actions } from '../features/admin-subs-slice';
// import { saveSubscrChange } from '../features/admin-subs.thunk';
import { openDetail, 
  performSearch, 
  showSection_Entry,
  showSection_Search, 
  updateStatus_Approve, 
  updateStatus_Reject,
  saveChange } from '../controllers/admin-subs';

import { ZetaSection, ZetaGroup } from "../zeta-widget"
import { showAlert } from '../zeta-widget/tools/alert-tool'

const { CONFIRM_ALERT } = require('../configs/default-option.json');
const { 
  TITLE_APPROVE_SUBSCR, CONFIRM_APPROVE_SUBSCR, 
  TITLE_REJECT_SUBSCR, CONFIRM_REJECT_SUBSCR,
  PLS_SELECT_ITEM
} = require('../configs/msg-th.json');
const tplSearch = require('../templates/admin-subs-search.json');
const tplDetail = require('../templates/admin-subs-detail.json');
const tplEntry = require('../templates/admin-subs-entry.json');

export function AdminSubscriptionPage(props) {
  const activeSection = useSelector(state => state.adminSubs.activeSection);
  const searchData = useSelector((state) => state.adminSubs.searchData);
  const data = useSelector((state) => state.adminSubs.data);
  const [showStatus, setShowStatus] = useState(true);

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.match(/subs\/(pending|expired)/i)) {
      setShowStatus(false);
    } else {
      setShowStatus(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    console.info('Will search...');
    const cond = { keyword: searchData.keyword, status : searchData.status };
    if (location.pathname.match(/subs\/pending/i)) {
      cond.status = 'N|P|W'; // always force this filter for pending page
    } else if (location.pathname.match(/subs\/expired/i)) {
      cond.status = 'A'; // always force this filter for expired page
    }

    performSearch(dispatch, cond);
    showSection_Search(dispatch);
  }, [dispatch, location.pathname, searchData.keyword, searchData.status]);

  const handleFilterChange = useCallback((e) => {
    const _searchData = { ...searchData };
    _searchData[e.target.name] = e.target.value;
    dispatch(actions.setSearchData(_searchData));
  }, [dispatch, searchData]);

  const handleFoundClick = useCallback(
    (idx) => {
      // console.info('Click ...', idx, searchData.found[idx]);
      const _id = searchData.found[idx]._id;
      openDetail(dispatch, _id);
    },
    [dispatch, searchData.found]
  );

  const handleActionClick = useCallback((e) => {
    if (e.target.name === 'btnBack') {
      showSection_Search(dispatch);
      return;
    }

    if (e.target.name === 'btnEdit') {
      showSection_Entry(dispatch);
      return;
    }

    if (e.target.name === 'btnSave') {
      saveChange(dispatch, data._id, data.pkg_expire, data.pkg_price, data.pkg_user_limit, data.pkg_status);
      return;
    }

    console.info(e.target);
    if (!data || !data._id) {
      showAlert(PLS_SELECT_ITEM, 'warning', true);
      return;
    }

    const _options = { ...CONFIRM_ALERT };
    
    switch(e.target.name) {
      case 'btnApprove':
        _options.title = TITLE_APPROVE_SUBSCR;
        _options.message = CONFIRM_APPROVE_SUBSCR;
        _options.buttons[0].onClick = () => {updateStatus_Approve(dispatch, data._id)}
        break;

      default:
        _options.title = TITLE_REJECT_SUBSCR;
        _options.message = CONFIRM_REJECT_SUBSCR;
        _options.buttons[0].onClick = () => {updateStatus_Reject(dispatch, data._id)}
        break;
    }
    
    confirmAlert(_options);    
  }, [data, dispatch]);

  const handleChange = useCallback((e) => {
    const _data = {...data};
    
    _data[e.target.name] = e.target.value;
    if (Object.keys(data).length === 0) {
      dispatch(actions.updateData(_data));
    } else {
      dispatch(actions.setData(_data));
    }
  },[data, dispatch])

  const handlers = {
    handleFilterChange,
    handleFoundClick,
    handleActionClick
  }

  const _this = {
    activeSection,
    handlers,

    showStatus,
  }

  return (
    <>
      <ZetaSection name="search" title="สืบค้นการสมัคร" app={_this}>
        <ZetaGroup template={tplSearch} data={searchData} app={_this} />
      </ZetaSection>

      <ZetaSection name="detail" title="รายละเอียดการสมัคร" app={_this}>
        <ZetaGroup size="medium" template={tplDetail} data={data} app={_this} />
      </ZetaSection>

      <ZetaSection name="entry" title="แก้ไขการสมัคร" app={_this}>
        <ZetaGroup size="medium" template={tplEntry} data={data} app={_this} onChange={handleChange} />
      </ZetaSection>

    </>
  )
}